import styled from '@emotion/styled';
import {ReactNode} from 'react';
import {Heading2} from '@styles/reusable';
import { useI18n } from '@i18n/useI18n';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';

export const Template = styled.div<{ fixedHeight: boolean }>`
  position: relative;
  display: flex;
  width: var(--site-width);
  margin: 0 var(--padding);
  --templateHeight: calc(100vh - var(--header-height) - 46px);
  height: ${(props) => (props.fixedHeight ? `calc(var(--templateHeight) - 46px)` : '100%')};
  min-height: var(--templateHeight);
  /* padding-top: 32px; */
  flex-direction: column;

  ${mq(Devices.mobile)}{
    margin: 0 auto;
    width: calc(100% - 10px);
  }
`;

const Footer = styled.div`
  position: absolute;
  bottom: 40px;
  left: 0;
`;

interface DefaultTemplateProps {
  children?: ReactNode;
  title?: string;
  footer?: string;
  highlightTitle?: string;
  fixedHeight?: boolean;
}

export const DefaultTemplate = ({ children, highlightTitle, footer, title, fixedHeight }: DefaultTemplateProps) => {
  const i18n = useI18n();

  return (
    <Template fixedHeight={fixedHeight}>
      {title && (
        <Heading2>
          {i18n.t(title)} {highlightTitle && <b>{highlightTitle.toUpperCase()}</b>}
        </Heading2>
      )}
      {children}
      <Footer>{footer}</Footer>
    </Template>
  );
};

export default DefaultTemplate;
